"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
/**@deprecated - use the common Duration instead */
exports.DurationTransport = typebox_1.Type.Object({
    value: typebox_1.Type.Number(),
    unit: typebox_1.Type.String(),
});
//# sourceMappingURL=duration-transport.js.map